import { createRoot } from "react-dom/client";
import App from "../../map/app";

const container = document.getElementById("leaflet-map");

if (container) {
  const detourId = container.getAttribute("data-detour-id");

  const fase = container.getAttribute("data-detour-fase");
  const faseNumber = fase ? parseInt(fase) : null;

  const root = createRoot(container);
  root.render(
    <App detourId={detourId} fase={faseNumber} className="h-[inherit] z-[inherit]" showDetours />
  );
}
